import React from 'react'

import { Helmet } from 'react-helmet'

import TopMenu from '../components/top-menu'
import Footer from '../components/footer'
import './foton.css'

const Foton = (props) => {
  return (
    <div className="foton-container10">
      <Helmet>
        <title>FOTON Brand and Landing Page | Vlad Butucariu</title>
        <meta
          name="description"
          content="Brand identity and landing-page design for FOTON, translating a complex digital-asset platform into a clear and consistent public experience."
        />
        <meta
          property="og:title"
          content="FOTON Brand and Landing Page | Vlad Butucariu"
        />
        <meta
          property="og:description"
          content="A visual identity and communication system connecting FOTON's product, website, and iconography."
        />
        <meta
          property="og:image"
          content="https://vladbutucariu.com/Images/og-default.png"
        />
        <link rel="canonical" href="https://vladbutucariu.com/foton" />
        <meta property="og:url" content="https://vladbutucariu.com/foton" />
      </Helmet>
      <div className="foton-thq-wrapper-elm">
        <TopMenu text3="Capabilities"></TopMenu>
        <div className="foton-thq-top-section-elm">
          <div className="foton-thq-video-div-elm">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="foton-video"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="foton-thq-video-mobile-elm"
            ></video>
          </div>
          <div className="foton-thq-section-elm1">
            <div className="foton-thq-color-wrapper-elm1 project-page-shell">
              <div className="foton-container11 project-page-intro">
                <div className="foton-container12">
                  <div className="foton-container13">
                    <img
                      alt="image"
                      src="/Images/tickerpurple.200.svg"
                      className="foton-image10"
                    />
                    <div className="foton-thq-title-elm">
                      <h1 className="foton-text10 header-project">
                        <span>FOTON – Brand and Landing Page</span>
                        <br></br>
                      </h1>
                    </div>
                    <div className="foton-thq-subtitle-elm">
                      <div className="foton-thq-description-elm1">
                        <h2 className="foton-thq-heading-elm">
                          <span>
                            FOTON&apos;s brand and public-facing experience were
                            developed alongside its product design, translating
                            a technically complex platform into a clear visual
                            identity, communication system, and landing
                            experience for creators and collectors.
                          </span>
                          <br></br>
                        </h2>
                      </div>
                      <div className="foton-thq-tags-elm">
                        <label className="tag-label-big foton-text15">
                          communication
                        </label>
                        <label className="foton-text16 tag-label-big">
                          webpage
                        </label>
                        <label className="tag-label-big foton-text17">
                          brand
                        </label>
                        <a
                          href="https://foton.is"
                          target="_blank"
                          rel="noreferrer noopener"
                          className="foton-link"
                        >
                          <label className="foton-text18 tag-label-big">
                            https://foton.is
                          </label>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="foton-thq-description-elm2">
                  <div className="foton-container14">
                    <span className="foton-text19">context</span>
                    <span className="foton-text20">
                      In a fast-growing NFT and DeFi landscape, FOTON needed a
                      distinct identity that reflected both technological
                      innovation and accessibility. Many competing marketplaces
                      focused heavily on technical features, often neglecting
                      clarity and emotional connection. The challenge was to
                      design a brand and landing experience that explained
                      complex Web3 concepts in a simple, engaging way while
                      showcasing the platform’s strengths — flexibility, creator
                      empowerment, and a painless experience overall.
                    </span>
                  </div>
                  <div className="foton-container15">
                    <span className="foton-text21">Design</span>
                    <span className="foton-text22">
                      <span>
                        Process: I began by defining the brand strategy —
                        identifying FOTON’s core values (clarity, empowerment,
                        innovation) and translating them into a visual and
                        verbal identity. The design language emphasised bold
                        typography, clean layouts, and a modern aesthetic to
                        convey confidence and trust.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>
                        For the landing page, I structured the experience around
                        clarity and user action, focusing on clear storytelling
                        to communicate FOTON’s unique features — from advanced
                        creator tools and flexible NFT use cases to Radix-native
                        security — through concise messaging supported by
                        visuals. A strong visual hierarchy, built on sharp
                        contrasts and modular sections, guided users naturally
                        through key value propositions and calls to action.
                        Throughout the design, I maintained consistency with the
                        product interface, ensuring a seamless brand experience
                        from the very first impression through to platform
                        onboarding. 
                      </span>
                      <br></br>
                      <br></br>
                      <span>
                        Subtle motion, Interactive Elements, and 3D iconography
                        were used to make the page feel alive while maintaining
                        a professional tone suitable for the Web3 audience. To
                        complement the 3D iconography and visuals applied within
                        the identity, between the sections of the website were
                        inserted quotes by characters from well known computers
                        games as to appeal to digital creators and surprise
                        visitors with small easter eggs.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                    </span>
                  </div>
                  <div className="foton-container16">
                    <span className="foton-text28">Results</span>
                    <span className="foton-text29">
                      The resulting identity gave the product one consistent
                      language across the website, interface, iconography, and
                      communication. The landing page organized the platform&apos;s
                      value around clear creator and collector needs rather than
                      relying on technical terminology alone.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="foton-thq-section-elm2">
          <div className="foton-thq-label-elm">
            <span className="foton-text32">Loopers</span>
            <span className="foton-text33">
              animation, nft, collection, art
            </span>
          </div>
          <div className="foton-container20">
            <div className="foton-thq-item-elm10">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="foton-image11"
              />
            </div>
            <div className="foton-thq-item-elm11">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="foton-image12"
              />
            </div>
            <div className="foton-thq-item-elm12">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="foton-image13"
              />
            </div>
            <div className="foton-thq-item-elm13">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="foton-image14"
              />
            </div>
            <div className="foton-thq-item-elm14">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="foton-image15"
              />
            </div>
            <div className="foton-thq-item-elm15">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="foton-image16"
              />
            </div>
            <div className="foton-thq-item-elm16">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="foton-image17"
              />
            </div>
            <div className="foton-thq-item-elm17">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="foton-image18"
              />
            </div>
            <div className="foton-thq-item-elm18">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="foton-image19"
              />
            </div>
            <div className="foton-thq-item-elm19">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="foton-image20"
              />
            </div>
            <div className="foton-thq-item-elm20">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="foton-image21"
              />
            </div>
            <div className="foton-thq-item-elm21">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="foton-image22"
              />
            </div>
            <div className="foton-thq-item-elm22">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="foton-image23"
              />
            </div>
            <div className="foton-thq-item-elm23">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="foton-image24"
              />
            </div>
            <div className="foton-thq-item-elm24">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="foton-image25"
              />
            </div>
            <div className="foton-thq-item-elm25">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="foton-image26"
              />
            </div>
            <div className="foton-thq-item-elm26">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="foton-image27"
              />
            </div>
            <div className="foton-thq-item-elm27">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="foton-image28"
              />
            </div>
          </div>
        </div>
        <div className="foton-thq-section-elm3">
          <div className="foton-thq-color-wrapper-elm2">
            <div className="foton-container21">
              <div className="foton-thq-pic-elm1">
                <img
                  alt="image"
                  src="/Projects/Web/foton%20webpage%2011.png"
                  className="foton-image29"
                />
                <div className="foton-container22">
                  <img
                    alt="image"
                    src="/Projects/Web/foton%20webpage%202.png"
                    className="foton-image30"
                  />
                </div>
                <div className="foton-container23">
                  <img
                    alt="image"
                    src="/Projects/Web/foton%20webpage%203.png"
                    className="foton-image31"
                  />
                  <div className="foton-thq-description-elm3">
                    <p className="foton-text34">
                      A unified visual language was built around 3D
                      illustrations and icons, reflecting the platform’s
                      playful, multidimensional spirit and echoing the creative
                      freedom offered by its innovative design tools.
                    </p>
                  </div>
                </div>
              </div>
              <img
                alt="image"
                src="/Projects/Web/foton%20webpage%2041.png"
                className="foton-image32"
              />
              <div className="foton-thq-pic-elm2">
                <img
                  alt="image"
                  src="/Projects/foton%20landing%201.jpg"
                  className="foton-image33"
                />
                <img
                  alt="image"
                  src="/Projects/foton%20landing%204.jpg"
                  className="foton-image34"
                />
                <img
                  alt="image"
                  src="/Projects/foton%20landing%202.jpg"
                  className="foton-image35"
                />
                <img
                  alt="image"
                  src="/Projects/foton%20landing%203.jpg"
                  className="foton-image36"
                />
                <img
                  alt="image"
                  src="/Projects/foton%20landing%205.jpg"
                  className="foton-image37"
                />
              </div>
              <div className="foton-thq-pic-elm3">
                <div className="foton-thq-description-elm4">
                  <p className="foton-text35">
                    With over 2 years in the making, the FOTON marketplace is
                    more than just a trading platform, it is a set of tools for
                    creators and builders. Many of these are a very first for
                    the DLT space, both in terms of technology but also in terms
                    of user experience and features. 
                  </p>
                </div>
                <img
                  alt="image"
                  src="/Projects/foton%20bento%205.png"
                  className="foton-image38"
                />
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
  )
}

export default Foton
